import React from "react";
import DatePicker from "react-datepicker";
import { localeDatePicker, stypes } from "../common/common";

class UserTripsFilter extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			filter: this.props.filter,
			carsForFilter: this.props.carsForFilter,
			isShowFilter: false,
		};
	}

	componentDidMount() {
		if (this.state.filter?.stype) {
			this.setState({
				isShowFilter: true,
			});
		}
	}

	componentWillReceiveProps(props) {
		this.setState({
			filter: props.filter,
			carsForFilter: props.carsForFilter,
		});
		if (Object.keys(this.props.filter).length === 0) {
			this.setState({
				isShowFilter: false,
			});
		} else {
			this.setState({
				isShowFilter: true,
			});
		}
	}

	resetFilter = () => {
		this.props.resetFilter();
		this.setState({
			isShowFilter: false,
		});
	};

	onFilterChange = (event) => {
		var filter;
		if (event.target.name !== "carId") {
			filter = {
				...this.props.filter,
				carId: "",
				[event.target.name]: event.target.value,
			};
		} else {
			filter = {
				...this.props.filter,
				[event.target.name]: event.target.value,
			};
		}
		this.props.setFilter(filter);
		this.props.getTrips(filter);
		this.setState({
			isShowFilter: true,
		});
	};

	onFromTimeChange = (date) => {
		const filter = {
			...this.props.filter,
			fromTime: date.valueOf(),
		};
		this.props.setFilter(filter);
		this.props.getTrips(filter);
	};

	onToTimeChange = (date) => {
		const filter = {
			...this.props.filter,
			toTime: date.valueOf(),
		};
		this.props.setFilter(filter);
		this.props.getTrips(filter);
	};

	render() {
		const hasFilter = this.props.checkHasFilter();
		const viewMode = this.props.viewMode;
		const mode = this.props.mode;
		const carsForFilter = this.state.carsForFilter;
		const stype = this.state.filter.stype;
		const isShowFilter = this.state.isShowFilter;

		const sortValue =
			this.state.filter && this.state.filter.sort > 0 ? this.state.filter.sort : this.props.defaultFilter.sort;
		const userTypeValue =
			this.state.filter && this.state.filter.userType > 0
				? this.state.filter.userType
				: this.props.defaultFilter.userType;
		const carId =
			this.state.filter && this.state.filter.carId ? this.state.filter.carId : this.props.defaultFilter.carId;
		const status =
			this.state.filter && this.state.filter.status > 0 ? this.state.filter.status : this.props.defaultFilter.status;
		const fromTime =
			this.state.filter && this.state.filter.fromTime > 0
				? this.state.filter.fromTime
				: this.props.defaultFilter.fromTime;
		const toTime =
			this.state.filter && this.state.filter.toTime > 0 ? this.state.filter.toTime : this.props.defaultFilter.toTime;

		return (
			<div className="trip-filter">
				<p className="title">Chế độ</p>
				<div className="trip-filter-radio">
					<div className="custom-radio">
						<input
							type="radio"
							value={stypes.SD}
							id={stypes.SD}
							name="stype"
							checked={stype === stypes.SD.toString()}
							onChange={this.onFilterChange}
						/>
						<label htmlFor={stypes.SD}>Xe tự lái</label>
					</div>
					<div className="custom-radio">
						<input
							type="radio"
							id={stypes.WD}
							value={stypes.WD}
							name="stype"
							checked={stype === stypes.WD.toString()}
							onChange={this.onFilterChange}
						/>
						<label htmlFor={stypes.WD}>Xe có tài xế</label>
					</div>
				</div>
				<div className="trip-filter-select">
					{isShowFilter && mode == viewMode.TRIPS && (
						<div className="custom-input">
							<div className="wrap-info">
								<div className="title-status">
									<p>Sắp xếp</p>
								</div>
							</div>
							<div className="custom-select">
								<select name="sort" onChange={this.onFilterChange} value={sortValue}>
									<option value={3}>Ưu tiên thay đổi</option>
									<option value={1}>Ưu tiên thời gian đặt</option>
									<option value={2}>Ưu tiên thời gian khởi hành</option>
								</select>
							</div>
						</div>
					)}
					{isShowFilter && (
						<React.Fragment>
							<div className="custom-input">
								<div className="wrap-info">
									<div className="title-status">
										<p>Lọc theo</p>
									</div>
								</div>
								<div className="custom-select">
									<select name="userType" onChange={this.onFilterChange} value={userTypeValue}>
										<option value={0}>Tất cả</option>
										<option value={1}>Chuyến thuê</option>
										<option value={2}>Chuyến cho thuê</option>
									</select>
								</div>
							</div>
							<div className="custom-input">
								<div className="wrap-info">
									<div className="title-status">
										<p>Trạng thái</p>
									</div>
								</div>
								<div className="custom-select">
									{mode == viewMode.TRIPS ? (
										<select name="status" onChange={this.onFilterChange} value={status}>
											<option value={0}>Tất cả</option>
											<option value={1}>Chờ duyệt</option>
											<option value={2}>Đã duyệt</option>
											<option value={3}>Đã đặt cọc</option>
											<option value={4}>Đang thuê</option>
											<option value={5}>Đã kết thúc</option>
										</select>
									) : (
										<select name="status" onChange={this.onFilterChange} value={status}>
											<option value={0}>Tất cả</option>
											<option value={1}>Chờ duyệt</option>
											<option value={2}>Đã từ chối</option>
											<option value={3}>Đã duyệt</option>
											<option value={4}>Đang đặt cọc</option>
											<option value={5}>Đã hủy</option>
											<option value={6}>Đang thuê</option>
											<option value={7}>Đã kết thúc</option>
										</select>
									)}
								</div>
							</div>
						</React.Fragment>
					)}
					{isShowFilter && mode == viewMode.HISTORY && (
						<React.Fragment>
							<div className="custom-input">
								<div className="wrap-info">
									<div className="title-status">
										<p>Bắt đầu</p>
									</div>
								</div>
								{fromTime && fromTime > 0 ? (
									<div className="wrap-input datepicker">
										<DatePicker
											locale={localeDatePicker}
											selected={new Date(fromTime)}
											timeFormat="HH:mm"
											dateFormat="dd/MM/yyyy"
											onChange={this.onFromTimeChange}
										/>
									</div>
								) : (
									<div className="wrap-input datepicker">
										<DatePicker
											locale={localeDatePicker}
											timeFormat="HH:mm"
											dateFormat="dd/MM/yyyy"
											placeholderText="Bất kì"
											onChange={this.onFromTimeChange}
										/>
									</div>
								)}
							</div>
							<div className="custom-input">
								<div className="wrap-info">
									<div className="title-status">
										<p>Kết thúc</p>
									</div>
								</div>
								{toTime && toTime > 0 ? (
									<div className="wrap-input datepicker">
										<DatePicker
											locale={localeDatePicker}
											selected={new Date(toTime)}
											timeFormat="HH:mm"
											dateFormat="dd/MM/yyyy"
											onChange={this.onToTimeChange}
										/>
									</div>
								) : (
									<div className="wrap-input datepicker">
										<DatePicker
											locale={localeDatePicker}
											timeFormat="HH:mm"
											dateFormat="dd/MM/yyyy"
											placeholderText="Bất kì"
											onChange={this.onToTimeChange}
										/>
									</div>
								)}
							</div>
						</React.Fragment>
					)}
					{isShowFilter && userTypeValue !== 1 && (
						<div className="custom-input">
							<div className="wrap-info">
								<div className="title-status">
									<p>Theo xe</p>
								</div>
							</div>
							<div className="custom-select">
								<select name="carId" onChange={this.onFilterChange} value={carId}>
									<option value="">Tất cả</option>
									{carsForFilter &&
										carsForFilter.map((option) => (
											<option key={option.id} value={option.id}>
												{option.name}
											</option>
										))}
								</select>
							</div>
						</div>
					)}
				</div>
				<div className="line-page" />
				<div className="apply-button">
					<a className="btn btn-cancel" onClick={this.resetFilter}>
						Xoá bộ lọc
					</a>
					<a className="btn btn-primary btn--s" onClick={this.props.toggleFilterTrip}>
						Áp dụng
					</a>
				</div>
			</div>
		);
	}
}
export default UserTripsFilter;
